import Repository from '../../Repository';

const resource = '/order-change-app/edit-history';

export default {
  index(data = {}) {
    return Repository.get(resource, data);
  },
  store(data) {
    return Repository.post(resource, data);
  },
  show(id) {
    return Repository.get(`${resource}/${id}`);
  },
  update(id, data) {
    return Repository.put(`${resource}/${id}`, data);
  },
  destroy(id) {
    return Repository.delete(`${resource}/${id}`);
  },
};
